function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".icon_approv_a{fill:#8dc640;}.icon_approv_b{opacity:0.2;}.icon_approv_c{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_approv_a",
  d: "M21.682,22.391c-3.677,3-15.159,3-18.762,0-3.677-3-3.3-15.814,0-19.187s15.46-3.373,18.762,0S25.359,19.393,21.682,22.391Z",
  transform: "translate(-0.301 -0.639)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon_approv_b",
  transform: "translate(0.011 0)"
}, React.createElement("path", {
  className: "icon_approv_c",
  d: "M12.573,16.506A17.585,17.585,0,0,1,2.142,20.553C-.41,16.206.116,5.638,3.118,2.565,5.819-.208,14.3-.732,19.178.992,20.378,5.938,17.9,12.234,12.573,16.506Z",
  transform: "translate(-0.509 0)"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_approv_c",
  d: "M88.663,114.724a1.605,1.605,0,0,1-1.351-.675l-4.2-5.4a1.71,1.71,0,0,1,2.7-2.1l2.852,3.672,6.3-8.169a1.71,1.71,0,0,1,2.7,2.1l-7.655,9.893A1.964,1.964,0,0,1,88.663,114.724Z",
  transform: "translate(-78.389 -96.046)"
});

var SvgApprov = function SvgApprov(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgApprov, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/approv.fdab0f40.svg";
export { ForwardRef as ReactComponent };